<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<wa-button [routerLink]="['/plugins']" appearance="plain" variant="neutral">Back to Plugins</wa-button>
		<wa-card appearance="outlined">
			<div class="wa-stack wa-gap-m">
				<div class="wa-stack wa-gap-s">
					<h1 waHeading="xl" waText>Local Storage Security</h1>
					<p waBody="m" waText>Local Storage Security &mdash; provides browser local storage access for device identification and session management. Creates unique UUID identifiers per browser instance, transports local storage variables via Ajax calls and WebSocket connections, and provides &#64;Named&#40;&quot;localstorage&quot;&#41; Guice injection for UUID and String.</p>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25+</wa-tag>
						<wa-tag pill variant="neutral">Angular 21</wa-tag>
						<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
						<wa-tag pill variant="neutral">WebSocket</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>COORDINATES &amp; MODULE</div>
					<p waBody="s" waText>Maven: com.jwebmp.plugins:localstorage</p>
					<p waBody="s" waText>JPMS Module: com.jwebmp.plugins.security.localstorage</p>
					<p waBody="s" waText>Built on: JWebMP Local Storage 1.0</p>
				</div>
				<wa-details summary="Installation">
					<div class="wa-stack wa-gap-xs">
						@if (!useGradle) {
							<div class="code-block-wrapper">
								<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Maven</div>
								<markdown [data]="mdContent_617" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
							</div>
						}
						@if (useGradle) {
							<div class="code-block-wrapper">
								<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Gradle &#40;Kotlin DSL&#41;</div>
								<markdown [data]="mdContent_618" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
							</div>
						}
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-m">
					<h2 waHeading="l" waText>Components &#40;3&#41;</h2>
					<p waBody="m" waText>Click any component to see its full API &mdash; properties, constructors, methods, events, slots, and examples.</p>
					<div class="wa-grid wa-gap-s" style="--min-column-size:18rem;">
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>LocalStoragePageConfigurator</h4>
								<p waBody="s" waColorText="quiet" waText>Page configurator that registers local storage support and sends a WebSocket 'LocalStorage' message on boot.</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">1 props</wa-tag>
									<wa-tag pill variant="neutral">3 methods</wa-tag>
									<wa-tag pill variant="success">1 examples</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/localstorage/local-storage-page-configurator']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>LocalStorageInterceptor</h4>
								<p waBody="s" waColorText="quiet" waText>Ajax call interceptor that reads/writes local storage UUID for device identification.</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="neutral">1 methods</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/localstorage/local-storage-interceptor']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>LocalStorageWSMessageReceiver</h4>
								<p waBody="s" waColorText="quiet" waText>WebSocket message receiver that handles 'LocalStorage' messages for session group management.</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="neutral">2 methods</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/localstorage/local-storage-wsmessage-receiver']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
					</div>
				</div>
				<wa-details summary="Features (5)">
					<div class="wa-stack wa-gap-xs">
						<p waBody="s" waColorText="quiet" waText>Device identification &mdash; unique UUID per browser via local storage</p>
						<p waBody="s" waColorText="quiet" waText>Ajax integration &mdash; local storage variables transported via AjaxCallIntercepter</p>
						<p waBody="s" waColorText="quiet" waText>WebSocket integration &mdash; session management via IWebSocketMessageReceiver</p>
						<p waBody="s" waColorText="quiet" waText>Guice injection &mdash; &#64;Named&#40;&quot;localstorage&quot;&#41; UUID and String providers in CallScope</p>
						<p waBody="s" waColorText="quiet" waText>Zero configuration &mdash; auto-registered via ServiceLoader SPI</p>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="Examples (1)">
					<div class="wa-stack wa-gap-m">
						<div class="wa-stack wa-gap-xs">
							<h4 waHeading="s" waText>Inject device ID</h4>
							<p waBody="s" waColorText="quiet" waText>Access the browser's unique device identifier via Guice injection.</p>
							<markdown [data]="mdContent_619" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
						</div>
					</div>
				</wa-details>
				<wa-details open summary="Quick Start">
					<markdown [data]="mdContent_620" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="SPI Extension Point Details (5)">
					<div class="wa-stack wa-gap-s">
						<div class="wa-stack wa-gap-xs">
							<div class="wa-cluster wa-gap-xs">
								<wa-tag pill variant="success">IPageConfigurator</wa-tag>
								<wa-tag pill variant="neutral">provides</wa-tag>
							</div>
							<p waBody="s" waColorText="quiet" waText>Registers local storage page configuration and WebSocket boot message</p>
						</div>
						<div class="wa-stack wa-gap-xs">
							<div class="wa-cluster wa-gap-xs">
								<wa-tag pill variant="success">IGuiceScanModuleInclusions</wa-tag>
								<wa-tag pill variant="neutral">provides</wa-tag>
							</div>
							<p waBody="s" waColorText="quiet" waText>Includes com.jwebmp.plugins.security.localstorage in Guice scanning</p>
						</div>
						<div class="wa-stack wa-gap-xs">
							<div class="wa-cluster wa-gap-xs">
								<wa-tag pill variant="success">IGuiceModule</wa-tag>
								<wa-tag pill variant="neutral">provides</wa-tag>
							</div>
							<p waBody="s" waColorText="quiet" waText>Binds &#64;Named&#40;&quot;localstorage&quot;&#41; UUID and String providers in CallScope</p>
						</div>
						<div class="wa-stack wa-gap-xs">
							<div class="wa-cluster wa-gap-xs">
								<wa-tag pill variant="success">IWebSocketMessageReceiver</wa-tag>
								<wa-tag pill variant="neutral">provides</wa-tag>
							</div>
							<p waBody="s" waColorText="quiet" waText>Handles 'LocalStorage' WebSocket messages for session management</p>
						</div>
						<div class="wa-stack wa-gap-xs">
							<div class="wa-cluster wa-gap-xs">
								<wa-tag pill variant="success">AjaxCallIntercepter</wa-tag>
								<wa-tag pill variant="neutral">provides</wa-tag>
							</div>
							<p waBody="s" waColorText="quiet" waText>Intercepts Ajax calls to read/write local storage device identifiers</p>
						</div>
					</div>
				</wa-details>
				<wa-details open summary="SPI Extension Points">
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">provides IPageConfigurator</wa-tag>
							<wa-tag pill variant="success">provides IGuiceScanModuleInclusions</wa-tag>
							<wa-tag pill variant="success">provides IGuiceModule</wa-tag>
							<wa-tag pill variant="success">provides IWebSocketMessageReceiver</wa-tag>
							<wa-tag pill variant="success">provides AjaxCallIntercepter</wa-tag>
						</div>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="Prerequisites">
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25 LTS</wa-tag>
						<wa-tag pill variant="neutral">Maven 3.9+</wa-tag>
						<wa-tag pill variant="neutral">Node.js 18+</wa-tag>
						<wa-tag pill variant="neutral">Angular 21+</wa-tag>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<div class="wa-cluster wa-gap-s">
					<wa-tag pill variant="neutral">Upstream: https://github.com/JWebMP/LocalStorage</wa-tag>
					<wa-tag pill variant="neutral">Source: https://github.com/JWebMP/LocalStorage</wa-tag>
				</div>
			</div>
		</wa-card>
	</div>
</div>